import {ofType} from 'redux-observable';
import {of} from 'rxjs';
import {flatMap, catchError, mergeMap} from 'rxjs/operators';

import {combineEpics} from 'web-app/util/redux-observable';
import {fetchRevenueReportObservable} from 'web-app/react/plans/revenue-report/epics';
import {FIRST_DAY_OF_YEAR, LAST_DAY_OF_YEAR} from 'web-app/react/plans/revenue-report/constants';

import * as Actions from './actions';

const fetch = action$ =>
    action$.pipe(
        ofType(Actions.fetch.type),
        mergeMap(({payload}: ReturnType<typeof Actions.fetch.action>) => {
            return fetchRevenueReportObservable(
                payload.targetId,
                payload.targetType,
                `${payload.year}-${FIRST_DAY_OF_YEAR}`,
                `${payload.year}-${LAST_DAY_OF_YEAR}`,
                payload.refresh,
                action$,
            ).pipe(
                flatMap(({response, actions}) => actions.concat(Actions.fetchSuccess.action(response))),
                catchError(e => of(Actions.fetchFailed.action(e))),
            );
        }),
    );

export default combineEpics(fetch);
